module.exports = __webpack_public_path__ + "assets/img/churn-percent.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/churn-percent.svg
// module id = 563
// module chunks = 0